import { Badge, BlockStack, Button, Card, Icon, InlineStack, Pagination, Tabs, Text } from '@shopify/polaris';
import { ChevronRightMinor, ClockMinor } from '@shopify/polaris-icons';
import React, { useCallback, useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import { CircleRedCross, NoActionIcon } from '../../../../Asests/svgIcon/icon';
import styles from '../css/overview.module.css';
import { ordersFilter, syncStatusOpt } from '../../NewAllSales/Utils/Constants';
import { appBridgeRouting } from '../../Panel/index';
import { formatDate, returnActionName, shipmentToBeDoneDesc } from '../Utils/HelperFunc';
import { stringWithTooltip } from '../../Function';
import { gridFilters } from '../../Listing Grid/Utilities/Constants';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

interface props extends DIProps {
    nationalOrders: any
    bopisOrders: any
    recentShipmentOrders: any
}

const Actions = (props: props) => {
    const { t } = useTranslation();
    const { nationalOrders, recentShipmentOrders } = props;
    const today = new Date(new Date().setHours(0, 0, 0, 0));
    const limit: number = 5;
    const [selected, setSelected] = useState(0);
    let [totalPage, setTotalPage] = useState<number>(0);
    const [totalErrorCount, setTotalErrorCount] = useState<number | String>('0');
    let [skip, setSkip] = useState<number>(0);
    let [rows, setRows] = useState<any[]>([]);
    let [page, setPage] = useState<number>(1);
    const { syncStatusOption } = syncStatusOpt()

    useEffect(() => {
        getAllErrorCount();
    }, [])

    useEffect(() => {
        getAllErrorMsgCount();
    }, [skip])


    useEffect(() => {
        if (Object.keys(recentShipmentOrders).length === 0) {
            if (Object.keys(nationalOrders).length === 0) {
                setSelected(2);
            } else {
                setSelected(1);
            }
        } else {
            setSelected(0);
        }
    }, [recentShipmentOrders, totalErrorCount, nationalOrders]);

    const handleTabChange = useCallback((selectedTabIndex: number) => setSelected(selectedTabIndex), []);

    // <<<<------Routing to Respective grid functions ------>>>
    const routeToOrdersGrid = (value: string, order_type: string, period?: { from: string, to: string }) => {
        let filter = JSON.parse(JSON.stringify({ ...ordersFilter }));
        if (value === 'Sync Status') {
            let sync_status = filter[value];
            sync_status['value'] = order_type;
            sync_status['label'] = syncStatusOption.filter((valueFilter: any) => valueFilter.value == order_type)[0]['label']
            sync_status['textValue'] = syncStatusOption.filter((valueFilter: any) => valueFilter.value == order_type)[0]['key']
            sync_status['change'] = true;
            if (sync_status['label'] === t('Failed Order')) sync_status['selectValue'] = '1'
            if (sync_status['label'] === t('Failed Shipment')) sync_status['selectValue'] = '10'
            if (sync_status['label'] === t('Failed Refund')) sync_status['selectValue'] = '3'
            if (sync_status['label'] === t('Failed Cancellation')) sync_status['selectValue'] = '1'
            if (sync_status['label'] === t('Refunded')) sync_status['selectValue'] = '3'
        }
        else if (value === "Orders") {
            let orders = filter[value];
            orders['from'] = period?.from;
            orders['to'] = period?.to;
            orders['textValue'] = order_type.split("_").join(" ")
            orders['label'] = t(order_type.split("_").join(" "))
            orders['change'] = true;
        }
        props.di.globalState.set('orders_filter', JSON.stringify(filter), true)
        appBridgeRouting("allSales", props)
    }

    const routeToLocalSellingGrid = () => {
        props.history("../localselling?tab=1", { replace: false, state: { linkClicked: 'order' } })
    }

    const routeToListingGrid = (value: string, errId?: string, errName?: string) => {
        props.di.globalState.removeLocalStorage("tabs");
        props.di.globalState.removeLocalStorage(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`);
        let filters = cloneDeep(gridFilters)
        if (value == 'viewAllErr' && errId == undefined && errName == undefined) {
            let activityFil = filters?.['Activity'];
            activityFil['textValue'] = 'error';
            activityFil['change'] = true;
            filters['activity'] = { ...activityFil }
        }
        else if (value == 'particularErr' && errId !== undefined && errName !== undefined) {
            let errorFil = filters?.['Error'];
            let messageFilter = filters?.['error_message'];
            let activityFil = filters?.['Activity'];
            errorFil['textValue'] = errId;
            errorFil['errorName'] = errName;
            errorFil['change'] = true;
            // messageFilter['textValue'] = errName;
            // messageFilter['errorName'] = errName;
            // messageFilter['change'] = true;
            filters['Error'] = { ...errorFil }
            // filters['error_message'] = { ...messageFilter }
            activityFil['textValue'] = 'error';
            activityFil['change'] = true;
            filters['Activity'] = { ...activityFil }
        }
        props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(filters), true);
        props.di.globalState.set("tabs", "5", true);

        appBridgeRouting('product', props)

        // Props.history("../product");
    }
    // <<<<------Routing to Respective grid functions ------>>>

    // <<<------- functions to render the structure in all three tabs ------>>>>
    const orderFailureStructure = (actionName: string, desc: string) => {
        return (
            <InlineStack gap="200" wrap={false} blockAlign='center' align='space-between'>
                <InlineStack gap="200" blockAlign='start' wrap={false}>
                    <div><Icon source={ClockMinor} tone="critical" /></div>
                    <BlockStack gap="100">
                        <Text as="p" fontWeight="medium">{returnActionName(actionName, t)}</Text>
                        <Text as="p" fontWeight="regular" tone="subdued">{nationalOrders?.[actionName] || 0} {nationalOrders?.[actionName] <= 1 ? t('order ') : t('orders ')} {desc}</Text>
                    </BlockStack>
                </InlineStack>
                <Button icon={ChevronRightMinor} onClick={() => routeToOrdersGrid('Sync Status', actionName)} />
            </InlineStack>
        )
    }

    const shipmentToBeDoneStructure = (actionName: string, showBopis?: boolean) => {
        return (
            <InlineStack gap="200" wrap={false} blockAlign='center' align='space-between'>
                <InlineStack gap="200" blockAlign='start' wrap={false}>
                    <div><Icon source={ClockMinor} tone={actionName == 'shipped_by_today' ? 'critical' : actionName == 'ready_for_pickup' ? 'critical' : 'caution'} /></div>
                    <BlockStack gap="100">
                        <InlineStack align='start' gap="100">
                            <Text as="p" fontWeight="medium">{t("Order Fulfilment")}</Text>
                            {(showBopis && showBopis === true) && <div><Badge tone='new'>{t("BOPIS")}</Badge></div>}
                        </InlineStack>
                        <InlineStack gap="100" blockAlign='center' align='start'>
                            <Text as="p" fontWeight="regular" tone="subdued">{recentShipmentOrders[actionName]} {recentShipmentOrders[actionName] <= 1 ? t(' Order') : t(" Orders")}</Text>
                            <Text as="p" fontWeight="regular" tone={actionName == 'shipped_by_today' ? 'critical' : actionName == 'ready_for_pickup' ? 'critical' : 'caution'}>{shipmentToBeDoneDesc(actionName, t)}</Text>
                        </InlineStack>
                    </BlockStack>
                </InlineStack>
                <Button
                    icon={ChevronRightMinor}
                    onClick={() => {
                        if (actionName === 'shipped_by_today') {
                            routeToOrdersGrid("Orders", "to_be_shipped_by_today", {
                                from: formatDate(new Date(new Date().setDate(today.getDate()))),
                                to: formatDate(new Date(new Date().setDate(today.getDate() + 1)))
                            })
                        }
                        else if (actionName === 'shipped_by_tomorrow') {
                            routeToOrdersGrid("Orders", "to_be_shipped_by_tomorrow", {
                                from: formatDate(new Date(new Date().setDate(today.getDate() + 1))),
                                to: formatDate(new Date(new Date().setDate(today.getDate() + 2)))
                            })
                        }
                        else if (actionName === 'ready_for_pickup') {
                            routeToLocalSellingGrid()
                        }
                    }}
                />
            </InlineStack>
        )
    }

    const productFailureStructure = (errorData: any, idx: number) => {
        return (
            <InlineStack gap="200" wrap={false} blockAlign='center' align='space-between' key={idx}>
                <InlineStack gap="200" blockAlign='start' wrap={false}>
                    <div><CircleRedCross /></div>
                    <BlockStack gap="100">
                        {stringWithTooltip(errorData?.msg, 70, true)}
                        <Text as="p" fontWeight="regular" tone="subdued">{errorData?.count || 0} {errorData?.count <= 1 ? t('product ') : t('products ')}</Text>
                    </BlockStack>
                </InlineStack>
                <Button icon={ChevronRightMinor} onClick={() => routeToListingGrid('particularErr', errorData?.['_id'], errorData?.['msg'])} />
            </InlineStack>
        )
    }
    // <<<------- functions to render the structure in all three tabs ------>>>>

    // <<<====== Product Failure APIs and pagination functions ======>>>>
    const getAllErrorCount = () => {
        let pages: number = 0;
        props.di.GET('connector/product/getAllErrorCount').then((data: any) => {
            if (data?.success) {
                data?.data?.forEach((item: any) => {
                    pages = Math.ceil(item?.count / limit)
                    setTotalPage(pages);
                    setTotalErrorCount(item?.count);
                })
            }
        })
    }

    const getAllErrorMsgCount = () => {
        let temp: any = {};
        let tempRow: any[] = [];
        props.di.POST('connector/product/getAllErrorMsgCount', {
            "skip": skip,
            "limit": limit,
            "formatted_error": true
        }).then((data: any) => {
            // typeof (err?.msg) === "object" ?
            // err?.msg?.[0]?.length > 70 ?
            //     err?.msg?.[0].substr(0, 70) + '... ' :
            //     err?.msg?.[0] :
            // err?.msg?.length > 70 ?
            //     err?.msg?.substr(0, 70) + '... ' :
            //     err?.msg;
            if (data?.success) {
                if (data?.data?.length !== 0) {
                    data?.data?.forEach((err: any) => {
                        if (err?.msg?.[0]) {
                            temp = {
                                _id: err?.['_id'],
                                msg: typeof (err?.msg) === "object" ? err?.msg?.[0] : err?.msg,
                                count: err?.count
                            };
                            tempRow?.push(temp)
                        }
                    })
                }
                setRows([...tempRow])
            }
            else props.error(t(data?.message))
        })
    }

    const onPrev = () => {
        if (page !== 1) {
            setPage(prev => prev - 1)
            setSkip((prevSkip) => prevSkip - limit)
        }
    }

    const onNext = () => {
        if (page !== totalPage) {
            setPage(prev => prev + 1)
            setSkip((prevSkip) => prevSkip + limit)
        }
    }


    const tabs: any = [
        {
            id: 'shipment',
            content: t('Shipment to be  done'),
            badge: typeof recentShipmentOrders === 'object' ? Object.keys(recentShipmentOrders).length?.toString() : "0",
            subcontent:
                Object.keys(recentShipmentOrders).length === 0 ?
                    <NoActionNeeded t={t} />
                    :
                    <BlockStack gap="400">
                        {recentShipmentOrders?.shipped_by_today > 0 ? shipmentToBeDoneStructure("shipped_by_today") : <></>}
                        {recentShipmentOrders?.ready_for_pickup > 0 ? shipmentToBeDoneStructure("ready_for_pickup", true) : <></>}
                        {recentShipmentOrders?.shipped_by_tomorrow > 0 ? shipmentToBeDoneStructure("shipped_by_tomorrow") : <></>}
                    </BlockStack>,
        },
        {
            id: 'order',
            content: t('Order Failures'),
            badge: typeof nationalOrders === 'object' ? Object.keys(nationalOrders).length?.toString() : '0',
            subcontent:
                Object.keys(nationalOrders).length === 0 ?
                    <NoActionNeeded t={t} />
                    :
                    <BlockStack gap="400">
                        {nationalOrders?.failed_order > 0 ? orderFailureStructure('failed_order', "failed to sync and were not created in the Shopify store") : <></>}
                        {nationalOrders?.failed_shipment > 0 ? orderFailureStructure('failed_shipment', "failed during shipment") : <></>}
                        {nationalOrders?.failed_refund > 0 ? orderFailureStructure('failed_refund', 'failed during refund process.') : <></>}
                        {nationalOrders?.failed_cancellation > 0 ? orderFailureStructure('failed_cancellation', 'failed during the cancellation process.') : <></>}
                        {nationalOrders?.national_failed_return > 0 ? orderFailureStructure('national_failed_return', 'failed during the return process.') : <></>}
                    </BlockStack>,
        },
        {
            id: 'product',
            content: t('Product Errors'),
            badge: totalErrorCount,
            subcontent:
                totalErrorCount === 0 ?
                    <NoActionNeeded t={t} />
                    :
                    <BlockStack gap="400">
                        <BlockStack gap="500">
                            {rows?.map((row: any, idx: number) => productFailureStructure(row, idx))}
                        </BlockStack>
                        <BlockStack align="end" inlineAlign='end'>
                            {totalPage > 1 && <Pagination label={`${page}/ ${totalPage || 0}`} hasPrevious={page != 1} hasNext={page != totalPage} onPrevious={() => onPrev()} onNext={() => onNext()} />}
                        </BlockStack>
                    </BlockStack>,
        }
    ];
    return (


        Object.keys(recentShipmentOrders).length === 0 && totalErrorCount == 0 && Object.keys(nationalOrders).length === 0 ? <></> : (<Card roundedAbove='sm'>
            <BlockStack gap="300">
                <BlockStack gap="200">
                    <Text variant="headingMd" as="h6">{t("Actions to be taken")}</Text>
                    <Text variant="bodyLg" as="p" tone="subdued">{t("Remain Informed about Shipment, Product, and Order Issues. Take Prompt and Effective Measures to Address and Overcome Any Challenges Presented.")}</Text>
                </BlockStack>
                <BlockStack gap="200">
                    <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} fitted />
                    <Card>{tabs[selected].subcontent}</Card>
                </BlockStack>
            </BlockStack>
        </Card>)

    );
}

export default DI(Actions);

const NoActionNeeded = (props: any) => {
    return (
        <BlockStack align='center' inlineAlign='center'>
            <NoActionIcon />
            <Text as='p' tone='subdued'>{props.t("Relax! No actions needed")}</Text>
        </BlockStack>

    )
}